import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { mq } from '../../helpers'
import { gsColors as c } from '../../styles/Variables'
import { faqAnswerToHtml, faqAnchorId } from '../../helpers/faq'

const FaqAccordion = ({ faqs = [] }) => {
  const [openId, setOpenId] = useState(null)

  useEffect(() => {
    if (typeof window === 'undefined') { return }
    const hash = window.location.hash?.replace('#', '')
    if (!hash) { return }
    const match = faqs.find((faq) => faqAnchorId(faq) === hash)
    if (match) {
      setOpenId(match.id)
      const el = document.getElementById(hash)
      if (el) {
        const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
        el.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' })
      }
    }
  }, [faqs])

  return (
    <AccordionWrapper>
      {faqs.map((faq) => {
        const question = faq.question || faq.title
        if (!question) { return null }
        const answer = faqAnswerToHtml(faq.answer ?? faq.body)
        const isOpen = openId === faq.id

        const answerId = `${faqAnchorId(faq)}-answer`

        return (
          <div
            key={faq.id}
            id={faqAnchorId(faq)}
            className='faq-item'
            data-faq-item
            data-open={isOpen}
          >
            <button
              type='button'
              className='faq-question'
              aria-expanded={isOpen}
              aria-controls={answerId}
              onClick={() => setOpenId(isOpen ? null : faq.id)}
            >
              <span>{question}</span>
              <span className='faq-icon' aria-hidden='true'>{isOpen ? '−' : '+'}</span>
            </button>
            <div
              id={answerId}
              className='faq-answer'
              inert={!isOpen}
              dangerouslySetInnerHTML={{ __html: answer }}
            />
          </div>
        )
      })}
    </AccordionWrapper>
  )
}

export default FaqAccordion

const AccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .faq-item {
    border-bottom: 1px solid #e0e0e0;
    scroll-margin-top: 100px;
  }

  .faq-question {
    width: 100%;
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 28px 0;
    text-align: left;
    color: #000;
    font-family: Garnett;
    font-size: 20px;
    font-weight: 600;
    line-height: 140%;

    ${mq('max', '800px')} {
      font-size: 18px;
      padding: 20px 0;
    }
  }

  .faq-icon {
    font-size: 28px;
    line-height: 1;
    color: ${c.cobalt};
    flex-shrink: 0;
  }

  .faq-answer {
    color: #333;
    font-family: Euclid;
    font-size: 18px;
    line-height: 160%;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;

    p {
      margin: 0 0 20px 0;

      &:last-child {
        margin-bottom: 0;
      }
    }

    a {
      color: ${c.cobalt};
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    ${mq('max', '800px')} {
      font-size: 16px;
    }
  }

  .faq-item[data-open='true'] .faq-answer {
    max-height: 2000px;
    padding: 0 0 28px 0;
  }
`
